/* template */
<template><div class="empty"><span class="text">{{ $t('home.noItem') }}～</span></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m04f86cf9"}'>
.empty
  width 600rpx
  height 600rpx
  margin 0 auto
  padding-top 200rpx
.text
  opacity 0.56
  font-size 24rpx
  color #666666
  text-align center
  display block
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
createComponent({
  name: 'empty',
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "empty04f86cf9",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
